/*
   ****** The below React component is developed by AECS Private Limited. ******
   Please don't remove, replace, or edit this header information
   Component: <Alarms.js>
   Description: This React component handles the display of all transactional data status. It will show all the alarms and vacTank level data.
   Dependencies: This component uses Material-UI components, moment for date formatting, and custom components like Header, Footer, and Sidebar.
*/
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import "../css/Dashboard.css";
import {
  settings,
  RefreshIconPage,
  ContentContainer,
  MainContent,
  CenteredCard,
  mapContainerStyle,
  center,
  HeaderTitle,
} from "../Styles/Dashboard";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Typography from "@mui/material/Typography";
import User from "../Pages/User";
import { useLogoTitle } from "../classes/LogoTitleContext";
import Header from "../Parts/Header";
import Footer from "../Parts/Footer";
import Sidebar from "../Parts/Sidebar";
import ExpandMoreIcon from "@mui/icons-material/ArrowDropDown";
import { green, red } from "@mui/material/colors";
import Box from "@mui/material/Box";
import { Gauge } from "@mui/x-charts/Gauge";
import RefreshIcon from "@mui/icons-material/Refresh";
import getAuthHeaders from "../Auth/Authentication";
import { API_ENDPOINTS } from "../Auth/apiConfig";
import refreshIconpage from "../Images/refresh-icon.svg";
import CellWifiOutlinedIcon from "@mui/icons-material/CellWifiOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import axios from "axios";
import Vaccum_Level from "../Images/DashboardIcons/vaccumlevel.png";
import Tank_Level from "../Images/DashboardIcons/tanklevel.png";
import Vaccum_Alarm from "../Images/DashboardIcons/vaccumalarm.png";
import Valve_Alarm from "../Images/DashboardIcons/valvealarm.png";
import Float_Alarm from "../Images/DashboardIcons/floatalarm.png";
import Pot_Alarm from "../Images/DashboardIcons/potalarm.png";
import Total_Valve_Cycles from "../Images/DashboardIcons/totalvalvecycles.png";
import Total_Valve_Duration from "../Images/DashboardIcons/totalvalveduration.png";
import Battery from "../Images/DashboardIcons/battery.png";
import Humidity from "../Images/DashboardIcons/humidity.png";
import Temperature from "../Images/DashboardIcons/temperature.png";

const Dashboard = ({ onLogout, userData, loggedInUser }) => {
  const [plcStatus, setPlcStatus] = useState(null);
  const [convertedProjectTime, setConvertedProjectTime] = useState(null);
  const [originalTime, setOriginalTime] = useState(null);
  const [isRecent, setIsRecent] = useState(null);
  const [ewonStatus, setEwonStatus] = useState(null);
  const [vaccum2Level, setVaccumTwoLevel] = useState(null);
  const [tank2Level, setTankTwoLevel] = useState(null);
  const [signalStatus, setSignalStatus] = useState("Loading...");
  const [vacuumLevel, setVacuumLevel] = useState(null);
  const [tanklevel, settankLevel] = useState(null);
  const [alarmCount, setAlarmCount] = useState(null);
  const [openAlarmCount, setOpenAlarmCount] = useState(null);
  const [ValveRowCount, setValvetotalCount] = useState(null);
  const [FloattotalCount, setFlaottotalCount] = useState(null);
  const [ValveAlarmCount, setValveAlarmCount] = useState(null);
  const [FloatAlarmCount, setFloatAlarmCount] = useState(null);
  const [totalValveAndFloatAlarmCount, setTotalValveAndFloatAlarmCount] =
    useState(null);
  const [receivedOnTime, setReceivedOnTime] = useState("");
  const [
    mostRecentValveAndFloatAlarmReceivedOnTime,
    setMostRecentValveAndFloatAlarmReceivedOnTime,
  ] = useState("N/A");
  const [VacAlarmreceivedOnTime, setVacAlarmReceivedOnTime] = useState("");
  const [ValveAlarmreceivedOnTime, setValveAlarmReceivedOnTime] = useState("");
  const [FloatAlarmreceivedOnTime, setFloatAlarmReceivedOnTime] = useState("");
  const [PotCyclereceivedOnTime, setPotCycleReceivedOnTime] = useState("");
  const [vacuumlevelLoading, setVacuumlevelLoading] = useState(false);
  const [tanklevelLoading, setTanklevelLoading] = useState(false);
  const [vacuumlevel2Loading, setVacuumlevel2Loading] = useState(false);
  const [tanklevel2Loading, setTanklevel2Loading] = useState(false);
  const [stationLoading, setStationLoading] = useState(false);
  const [valveLoading, setValveLoading] = useState(false);
  const [floatLoading, setFloatLoading] = useState(false);
  const [valveAndFloatLoading, setValveAndFloatLoading] = useState(false);
  const [totalValveCycles, setTotalValveCycles] = useState("");
  const [totalValveDuration, setTotalValveDuration] = useState("");
  const [averageBatteryVoltage, setAverageBatteryVoltage] = useState("");
  const [averageHumidity, setAverageHumidity] = useState("");
  const [averageTemperature, setAverageTemperature] = useState("");
  const [totalValveCyclesLoading, setTotalValveCyclesLoading] = useState("");
  const [totalValveDurationLoading, setTotalValveDurationLoading] = useState("");
  const [averageBatteryVoltageLoading, setAverageBatteryVoltageLoading] = useState("");
  const [averageHumidityLoading, setAverageHumidityLoading] = useState("");
  const [averageTemperatureLoading, setAverageTemperatureLoading] = useState("");

  <User onLogout={onLogout} userData={userData} />;
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [isLoggedIn, setIsLoggedIn] = useState();
  // eslint-disable-next-line
  const notify = (message) =>
    toast.info(message, {
      css: {
        fontSize: "16px",
        "@media (max-width: 600px)": {
          fontSize: "14px",
        },
      },
    });

  const [loading, setLoading] = useState(true);
  const [valveAlarmStatus, setValveAlarmStatus] = useState();
  const [username, setUsername] = useState();
  const [userRole, setUserRole] = useState("");
  const { logoUrl, projectTitle } = useLogoTitle();

  const handleVacuumAlarm = (cardTitle, e) => {
    e.stopPropagation();
    navigate("/Alarms");
  };

  const handleValveStatus = (cardTitle, e) => {
    e.stopPropagation();
    navigate("/PotAlarms");
  };

  const handleFloatStatus = (cardTitle, e) => {
    e.stopPropagation();
    navigate("/PotAlarms");
  };

  const handleBatteryStatus = (cardTitle, e) => {
    e.stopPropagation();
    navigate("/devices");
  };

  const handleMapViewClick = () => {
    navigate("/Map");
  };

  const fetchEwonStatus = async () => {
    try {
      //console.log('Fetching Ewon status...');
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.ewonStatus}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      if (!response.data) {
        throw new Error("Failed to fetch Ewon status");
      }
      setEwonStatus(response.data.ewonStatus);
      //console.log(`Fetched Ewon status: ${response.data.ewonStatus}`);
    } catch (error) {
      console.error("Error fetching Ewon status:", error.message);
    }
  };

  const fetchPlcStatus = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.plcStatus}?clientId=${loggedInUser.clientId}&TimeDiff=${loggedInUser.TimeDiff}`,
        {
          headers: authHeaders,
        }
      );

      if (!response.data) {
        throw new Error("Failed to fetch PLC status");
      }

      const { plcStatus, convertedProjectTime, originalTime, isRecent } =
        response.data;

      setPlcStatus(plcStatus);
      setConvertedProjectTime(convertedProjectTime);
      setOriginalTime(originalTime);
      setIsRecent(isRecent);

      // console.log(
      //   "Fetched PLC Status Data:",
      //   JSON.stringify(response.data, null, 2)
      // );
    } catch (error) {
      console.error("Error fetching PLC status:", error.message);
    }
  };

  const fetchSignalStatus = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.signalStatus}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );

      if (response.data && response.data.signalStatus !== undefined) {
        // Calculate the percentage
        const signalStatus = response.data.signalStatus;
        if (typeof signalStatus === "number") {
          const percentage = (signalStatus / 33) * 100;
          setSignalStatus(`${percentage.toFixed(0)}%`); // Set the percentage value with a '%' symbol
        } else {
          setSignalStatus("No data");
        }
      } else {
        setSignalStatus("No data");
      }
    } catch (error) {
      console.error("Error fetching signal status:", error.message || error);
      setSignalStatus("Error");
    }
  };

  const fetchVacuumLevel = async () => {
    try {
      //console.log('Fetching vacuum level...');
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.vacuumLevelbar}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      //console.log('Response received:', response.data);

      if (!response.data.success || !response.data.data.length) {
        throw new Error("No vacuum level data found");
      }

      const rawData = response.data.data[0].VaccumLevel;
      //console.log('Raw vacuum level data:', rawData);

      // Calculate vacuum level
      let vacuumLevelValue = 0.000625 * parseFloat(rawData) - 1.25;

      // Handle NaN or invalid values
      if (isNaN(vacuumLevelValue)) {
        vacuumLevelValue = 0;
      } else {
        vacuumLevelValue = vacuumLevelValue.toFixed(2);
      }

      //console.log('Calculated vacuum level value:', vacuumLevelValue);
      setVacuumLevel(vacuumLevelValue);
    } catch (error) {
      console.error("Error fetching vacuum level:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchtankLevel = async () => {
    try {
      //console.log('Fetching tank level...');
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.tankLevelm}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      if (!response.data.success || !response.data.data.length) {
        throw new Error("No tank level data found");
      }

      const rawData = response.data.data[0].TankLevel; // Extract TankLevel from the recordset
      //console.log('Raw tank level data:', rawData);

      // Validate and fetch coefficients from loggedInUser
      const tankLevelCoefficientDYX = loggedInUser.Dyx || 1; // Default coefficient
      const tankLevelCoefficientM = loggedInUser.M || 0; // Default coefficient

      // Calculate tank level value
      let tankLevelValue =
        tankLevelCoefficientDYX * parseFloat(rawData) - tankLevelCoefficientM;

      // Handle NaN or invalid values
      if (isNaN(tankLevelValue)) {
        tankLevelValue = 0;
      } else {
        tankLevelValue = tankLevelValue.toFixed(2);
      }

      //console.log('Calculated tank level value:', tankLevelValue);
      settankLevel(tankLevelValue);
    } catch (error) {
      console.error("Error fetching tank level:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchVaccumLevel2Data = async () => {
    try {
      //console.log('Fetching VacTankLvlsData...');
      const authHeaders = getAuthHeaders();

      const response = await axios.get(
        `${API_ENDPOINTS.VaccumTankLevels}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );

      // Ensure the response data exists
      if (!response.data || !response.data.success) {
        throw new Error("Failed to fetch VacTankLvlsData");
      }

      // Access the VaccumLevel2 value
      const vacuumLevel2 = response.data.data[0]?.VaccumLevel2; // Accessing the first item in the data array

      if (vacuumLevel2 !== undefined) {
        // Calculate the new value using the provided formula
        let calculatedValue = 0.000625 * parseFloat(vacuumLevel2) - 1.25;

        // Check if calculatedValue is NaN
        if (isNaN(calculatedValue)) {
          calculatedValue = 0; // Set to 0 if NaN
        } else {
          calculatedValue = calculatedValue.toFixed(2); // Format to 2 decimal places
        }

        // Set the calculated value to the state (if needed)
        setVaccumTwoLevel(calculatedValue); // Or store it in another state variable if required

        //console.log(`Fetched VaccumLevel2: ${vacuumLevel2}`);
        //console.log(`Calculated Value: ${calculatedValue}`);
      } else {
        console.error("VaccumLevel2 is not available in the response.");
      }
    } catch (error) {
      console.error("Error fetching VacTankLvlsData:", error.message);
    }
  };

  const fetchTankLevel2Data = async () => {
    try {
      //console.log('Fetching TankLevelData...');
      const authHeaders = getAuthHeaders();

      const response = await axios.get(
        `${API_ENDPOINTS.VaccumTankLevels}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );

      // Ensure the response data exists
      if (!response.data || !response.data.success) {
        throw new Error("Failed to fetch TankLevelData");
      }

      // Access the TankLevel2 value
      const tankLevel2 = response.data.data[0]?.TankLevel2; // Accessing the first item in the data array

      // Calculate the tank level value using the coefficients from loggedInUser
      if (tankLevel2 !== undefined) {
        const tankLevel2CoefficientDYX = loggedInUser.Dyx; // Get the coefficient from loggedInUser
        const tankLevel2CoefficientM = loggedInUser.M; // Get the coefficient from loggedInUser

        let tankLevelValue =
          tankLevel2CoefficientDYX * parseFloat(tankLevel2) -
          tankLevel2CoefficientM;

        // Check if tankLevelValue is NaN, if so, set it to 0
        if (isNaN(tankLevelValue)) {
          tankLevelValue = 0; // Set to 0 if NaN
        } else {
          tankLevelValue = tankLevelValue.toFixed(2); // Format to 2 decimal places
        }

        // Set the calculated tank level value to the state
        setTankTwoLevel(tankLevelValue);
        //console.log(`Fetched TankLevel2: ${tankLevel2}`);
        //console.log(`Calculated Tank Level Value: ${tankLevelValue}`);
      } else {
        console.error("TankLevel2 is not available in the response.");
      }
    } catch (error) {
      console.error("Error fetching TankLevelData:", error.message);
    }
  };

  const fetchAlarmCount = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.alarmCount}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      if (!response.data || !response.data.success) {
        throw new Error("Failed to fetch alarm count");
      }
      const totalCount = response.data.totalCount;
      setAlarmCount(totalCount.toString());
      //console.log('Alarm Count:', totalCount);
    } catch (error) {
      console.error("Error fetching alarm count:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataOpenAlarm = async () => {
    setLoading(true);
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(`${API_ENDPOINTS.openAlarm}`, {
        params: {
          IntTimeDiff: loggedInUser.TimeDiff,
          IntProjectId: loggedInUser.Projectid,
          clientId: loggedInUser.clientId,
        },
        headers: authHeaders,
      });
      //console.log('Response Data Open Alarm Count:', response.data);
      if (response.data && response.data.openAlarmCount !== undefined) {
        setOpenAlarmCount(response.data.openAlarmCount);
      } else {
        //console.log('Invalid response format:', response.data);
        setOpenAlarmCount(null);
      }
    } catch (error) {
      console.error("Error fetching open alarm count:", error);
      setOpenAlarmCount(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchValveCount = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.valveCount}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      //console.log('Response from server:', response);

      if (response.status !== 200 || !response.data) {
        throw new Error("Failed to fetch valve count");
      }
      const ValveRowCount = response.data.ValveRowCount;
      setValvetotalCount(ValveRowCount.toString());
      //console.log('Valve Count:', ValveRowCount);
    } catch (error) {
      console.error("Error fetching valve count:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchFloatCount = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.floatCount}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      //console.log('Response from server:', response);

      if (response.status !== 200 || !response.data) {
        throw new Error("Failed to fetch Float count");
      }
      const FloattotalCount = response.data.FloattotalCount;
      setFlaottotalCount(FloattotalCount.toString());
      //console.log('Float Count:', FloattotalCount);
    } catch (error) {
      console.error("Error fetching Float count:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchValveAlarmCount = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.valveAlarmCount}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      //console.log('Response from server:', response);

      if (response.status !== 200 || !response.data) {
        throw new Error("Failed to fetch Valve Alarm count");
      }
      const ValveAlarmCount = response.data.ValveAlarmCount;
      setValveAlarmCount(ValveAlarmCount.toString());
      //console.log('Valve Alarm Count:', ValveAlarmCount);
    } catch (error) {
      console.error("Error fetching Valve Alarm count:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchFloatAlarmCount = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.floatAlarmCount}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      //console.log('Response from server:', response);

      if (response.status !== 200 || !response.data) {
        throw new Error("Failed to fetch Valve Alarm count");
      }
      const FloatAlarmCount = response.data.FloatAlarmCount;
      setFloatAlarmCount(FloatAlarmCount.toString());
      //console.log('Float Alarm Count:', FloatAlarmCount);
    } catch (error) {
      console.error("Error fetching Float Alarm count:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchValveAndFloatMergeAlarmCounts = async () => {
    try {
      setValveAndFloatLoading(true);
      const authHeaders = getAuthHeaders();

      const response = await axios.get(
        `${API_ENDPOINTS.potAlarmCount}?clientId=${loggedInUser.clientId}`,
        { headers: authHeaders }
      );

      if (response.status !== 200 || !response.data) {
        throw new Error("Failed to fetch pot alarm counts");
      }

      const valveCount = parseInt(response.data.ValveAlarmCount, 10) || 0;
      const floatCount = parseInt(response.data.FloatAlarmCount, 10) || 0;

      const totalValveAndFloatAlarmCount = valveCount + floatCount;

      setValveAlarmCount(valveCount.toString());
      setFloatAlarmCount(floatCount.toString());
      setTotalValveAndFloatAlarmCount(totalValveAndFloatAlarmCount.toString());

      console.log("Merged Total Alarm Count:", totalValveAndFloatAlarmCount);
    } catch (error) {
      console.error("Error fetching and merging alarm counts:", error.message);
    } finally {
      setValveAndFloatLoading(false);
    }
  };

  const fetchValveAndFloatMergeAlarmReceivedOnTime = async () => {
    try {
      setValveAndFloatLoading(true);
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.receivedOnTime}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );

      const { LatestValveAlarmTime, LatestFloatAlarmTime } = response.data;

      const parseCustomDate = (str) => {
        if (!str) return null;
        const [datePart, timePart] = str.split(" ");
        const [day, month, year] = datePart.split("-");
        // Ensure two-digit parts and return ISO-style string
        return new Date(`${year}-${month}-${day}T${timePart}`);
      };

      const valveDate = parseCustomDate(LatestValveAlarmTime);
      const floatDate = parseCustomDate(LatestFloatAlarmTime);

      let mostRecent = "N/A";

      if (valveDate && floatDate) {
        mostRecent =
          valveDate > floatDate ? LatestValveAlarmTime : LatestFloatAlarmTime;
      } else if (valveDate) {
        mostRecent = LatestValveAlarmTime;
      } else if (floatDate) {
        mostRecent = LatestFloatAlarmTime;
      }

      // console.log(
      //   "[Valve vs Float Alarm Time]",
      //   "\nRaw - Valve:",
      //   LatestValveAlarmTime,
      //   "| Float:",
      //   LatestFloatAlarmTime,
      //   "\nParsed - Valve Date:",
      //   valveDate,
      //   "| Float Date:",
      //   floatDate,
      //   "\nSelected Most Recent:",
      //   mostRecent
      // );

      setMostRecentValveAndFloatAlarmReceivedOnTime(mostRecent);
    } catch (error) {
      console.error("Error fetching Valve and Float alarm times:", error);
      setMostRecentValveAndFloatAlarmReceivedOnTime("N/A");
    } finally {
      setValveAndFloatLoading(false);
    }
  };

  const fetchLoraNodeStatus = async () => {
    try {
      setLoading(true);

      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.GetLoraNodeStatus}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );

      if (!response.data || !response.data.data) {
        throw new Error("Failed to fetch Lora node status data");
      }

      const data = response.data.data;

      setTotalValveCycles(data.totalValveCycles);
      setTotalValveDuration(data.totalValveDuration);
      setAverageBatteryVoltage(data.averageBatteryVoltage);
      setAverageHumidity(data.averageHumidity);
      setAverageTemperature(data.averageTemperature);

    } catch (error) {
      console.error("❌ Error fetching Lora node status:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchReceivedOnTime = async () => {
    try {
      setLoading(true);
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.receivedOnTime}?clientId=${loggedInUser.clientId}`,
        {
          headers: authHeaders,
        }
      );
      //console.log('Backend response:', response.data);

      setReceivedOnTime(response.data.LatestVacTankTime || "N/A");
      setVacAlarmReceivedOnTime(response.data.LatestVacAlarmTime || "N/A");
      setValveAlarmReceivedOnTime(response.data.LatestValveAlarmTime || "N/A");
      setFloatAlarmReceivedOnTime(response.data.LatestFloatAlarmTime || "N/A");
      setPotCycleReceivedOnTime(response.data.LatestPotDataTime || "N/A");
    } catch (error) {
      console.error("Error fetching received on time:", error);
      setReceivedOnTime("N/A"); // Handle error state
      setVacAlarmReceivedOnTime("N/A");
      setValveAlarmReceivedOnTime("N/A");
      setFloatAlarmReceivedOnTime("N/A");
      setPotCycleReceivedOnTime("N/A");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Function to fetch all required data
    const fetchData = () => {
      fetchPlcStatus();
      fetchSignalStatus();
      fetchVacuumLevel();
      fetchtankLevel();
      fetchVaccumLevel2Data();
      fetchTankLevel2Data();
      fetchDataOpenAlarm();
      fetchValveAlarmCount();
      fetchFloatAlarmCount();
      fetchEwonStatus();
      fetchReceivedOnTime();
      fetchValveAndFloatMergeAlarmCounts();
      fetchValveAndFloatMergeAlarmReceivedOnTime();
      fetchLoraNodeStatus();
    };

    // Fetch data when the component mounts or when `loggedInUser` changes
    if (loggedInUser) {
      fetchData();

      // Set up an interval to refresh data every 15 seconds
      const intervalId = setInterval(fetchData, 15000); // 15000 milliseconds = 15 seconds

      // Clean up the interval on component unmount or if `loggedInUser` changes
      return () => clearInterval(intervalId);
    }
  }, [loggedInUser]);

  // Initialize PLConline and EwonOnline with their respective statuses.
  let PLConline = plcStatus == 1;
  let EwonOnline = ewonStatus == 1;

  // Override the status if loggedInUser.clientId is 508
  if (loggedInUser?.clientId == 508) {
    PLConline = true;
    EwonOnline = true;
  }

  const NoCommunication =
    ewonStatus == 1 ||
    loggedInUser.clientId == 387 ||
    loggedInUser.clientId == 407 ||
    loggedInUser.clientId == 508 ||
    loggedInUser.clientId == 392;

  const RedCloudIcon = () => (
    <svg
      width="60"
      height="130"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#FF0000"
        d="M51.76,29.07a12.83,12.83,0,0,0-24-8,8.49,8.49,0,0,0-1.86-.2,8.64,8.64,0,0,0-8.31,10.86A9.56,9.56,0,0,0,10,39.52,9.75,9.75,0,0,0,19.25,49H51.3a8.7,8.7,0,0,0,.46-17.37Z"
      />
    </svg>
  );

  const handleVacuumLevelRefresh = async () => {
    setVacuumlevelLoading(true);
    try {
      await fetchVacuumLevel();
      await fetchReceivedOnTime();
      notify("Vacuum Level (bar) refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Vacuum Level data:", error.message);
      //notify('Failed to refresh Vacuum Level (bar)');
    } finally {
      setVacuumlevelLoading(false);
    }
  };

  const handleTankLevelRefresh = async () => {
    setTanklevelLoading(true);
    try {
      await fetchtankLevel();
      await fetchReceivedOnTime();
      notify("Tank Level (m) refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Tank Level data:", error.message);
      //notify('Failed to refresh Tank Level (m)');
    } finally {
      setTanklevelLoading(false);
    }
  };

  const handleVacuumLevel2Refresh = async () => {
    setVacuumlevel2Loading(true);
    try {
      await fetchVaccumLevel2Data();
      await fetchReceivedOnTime();
      notify("Vacuum Level Two (bar) refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Vacuum Level Two data:", error.message);
      //notify('Failed to refresh Vacuum Level (bar)');
    } finally {
      setVacuumlevel2Loading(false);
    }
  };

  const handleTankLevel2Refresh = async () => {
    setTanklevel2Loading(true);
    try {
      await fetchTankLevel2Data();
      await fetchReceivedOnTime();
      notify("Tank Level Two (m) refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Tank Level Two data:", error.message);
      //notify('Failed to refresh Tank Level (m)');
    } finally {
      setTanklevel2Loading(false);
    }
  };

  const handleVacuumAlarmRefresh = async () => {
    setStationLoading(true);
    try {
      await fetchAlarmCount();
      await fetchReceivedOnTime();
      notify("Station Alarm refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Vacuum Alarm:", error.message);
      //notify('Failed to refresh Vacuum Level (bar)');
    } finally {
      setStationLoading(false);
    }
  };

  const handleValveAndFloatAlarmRefresh = async () => {
    setValveAndFloatLoading(true);
    try {
      await fetchValveAndFloatMergeAlarmCounts();
      await fetchValveAndFloatMergeAlarmReceivedOnTime();
      notify("Pot Alarms refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Pot Alarms:", error.message);
      //notify('Failed to refresh Vacuum Level (bar)');
    } finally {
      setValveAndFloatLoading(false);
    }
  };

  const handleValveAlarmRefresh = async () => {
    setValveLoading(true);
    try {
      await fetchValveAlarmCount();
      await fetchReceivedOnTime();
      notify("Valve Alarm refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Valve Alarm:", error.message);
      //notify('Failed to refresh Vacuum Level (bar)');
    } finally {
      setValveLoading(false);
    }
  };

  const handleFlatAlarmRefresh = async () => {
    setFloatLoading(true);
    try {
      await fetchFloatAlarmCount();
      await fetchValveAndFloatMergeAlarmReceivedOnTime();
      notify("Float Alarm refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Float Alarm:", error.message);
      //notify('Failed to refresh Vacuum Level (bar)');
    } finally {
      setFloatLoading(false);
    }
  };

  const handleTotalValveCycles = async () => {
    setTotalValveCyclesLoading(true);
    try {
      // Fire both fetch calls in parallel (don’t wait)
      await fetchLoraNodeStatus();
      await fetchReceivedOnTime();
      notify("Total Valve Cycles refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Total Valve Cycles:", error.message);
      // notify("Failed to refresh Vacuum Level (bar)");
    } finally {
      // Stop loader immediately (without waiting for async work)
      setTotalValveCyclesLoading(false);
    }
  };

  const handleAverageBattery = async () => {
    setAverageBatteryVoltageLoading(true);
    try {
      // Fire both fetch calls in parallel (don’t wait)
      await fetchLoraNodeStatus();
      await fetchReceivedOnTime();
      notify("Total Valve Duration refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Total Valve Duration:", error.message);
      // notify("Failed to refresh Vacuum Level (bar)");
    } finally {
      // Stop loader immediately (without waiting for async work)
      setAverageBatteryVoltageLoading(false);
    }
  };

  const handleTotalValveDuration = async () => {
    setTotalValveDurationLoading(true);
    try {
      // Fire both fetch calls in parallel (don’t wait)
      await fetchLoraNodeStatus();
      await fetchReceivedOnTime();
      notify("Total Valve Duration refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Total Valve Duration:", error.message);
      // notify("Failed to refresh Vacuum Level (bar)");
    } finally {
      // Stop loader immediately (without waiting for async work)
      setTotalValveDurationLoading(false);
    }
  };

  const handleAverageHumidity = async () => {
    setAverageHumidityLoading(true);
    try {
      // Fire both fetch calls in parallel (don’t wait)
      await fetchLoraNodeStatus();
      await fetchReceivedOnTime();
      notify("Humidity refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Humidity:", error.message);
      // notify("Failed to refresh Vacuum Level (bar)");
    } finally {
      // Stop loader immediately (without waiting for async work)
      setAverageHumidityLoading(false);
    }
  };

  const handleAverageTemperature = async () => {
    setAverageTemperatureLoading(true);
    try {
      // Fire both fetch calls in parallel (don’t wait)
      await fetchLoraNodeStatus();
      await fetchReceivedOnTime();
      notify("Temperature refreshed successfully");
    } catch (error) {
      console.error("Error refreshing Temperature:", error.message);
      // notify("Failed to refresh Vacuum Level (bar)");
    } finally {
      // Stop loader immediately (without waiting for async work)
      setAverageTemperatureLoading(false);
    }
  };

  const getIconColorForSignal = (strength) => {
    if (strength > "1%" && strength <= "54%") return "#ff0000"; // Red
    if (strength > "54%" && strength <= "75%") return "#ffa500"; // Orange
    if (strength > "75%") return "#008000"; // Green
    return "#000000"; // Default icon color
  };

  const iconColor = getIconColorForSignal(signalStatus);

  const topMargin = window.innerWidth < 768 ? "85px" : "70px";

  const formatDateTimePlcStatus = (isoString) => {
    if (!isoString) return "";

    const [datePart, timePart] = isoString.split("T");
    const [year, month, day] = datePart.split("-");
    const [hour, minute, second] = timePart.split(":");

    return `${day}/${month}/${year} ${hour}:${minute}:${second.split(".")[0]}`;
  };

  return (
    <div style={{ backgroundColor: "#EBEFF3" }}>
      <Sidebar loggedInUser={loggedInUser} />
      <Header
        logoUrl={logoUrl}
        loggedInUser={loggedInUser}
        onLogout={onLogout}
        username={username}
        userRole={userRole}
      />
      <ContentContainer>
        <MainContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <HeaderTitle>Dashboard</HeaderTitle>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <RefreshIconPage
                title="Refresh"
                src={refreshIconpage}
                alt="Refresh"
                onClick={() => window.location.reload()}
              />
            </Box>
          </Box>
          <Card
            sx={{
              maxWidth: "100%",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              margin: "10px 10px 25px 10px",
              backgroundColor: "#EBEFF3",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            {loggedInUser && loggedInUser.EwonPlcCardEnabled && (
              <Box
                position="absolute"
                top="10px"
                right="20px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                padding="5px"
                border="2px solid #bdbdbd"
                backgroundColor="#f8f9fa" // Light grey background
                style={{
                  minWidth: "250px", // Wider for side-by-side layout
                  textAlign: "center",
                  gap: "4px",
                }}
              >
                {/* Status Indicators in a Row */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap="6px" // Spacing between items
                  width="100%"
                >
                  {/* Ewon Status Indicator */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="4px"
                    padding="3px 6px"
                    style={{
                      backgroundColor: EwonOnline ? "#008000" : "#ff0000", // Green for Online, Red for Offline
                      color: "white",
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                    }}
                  >
                    <Typography variant="body2">
                      {EwonOnline ? "Router: Online" : "Router: Offline"}
                    </Typography>
                  </Box>

                  {/* PLC Status Indicator */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="4px"
                    padding="3px 6px"
                    style={{
                      backgroundColor: PLConline ? "#008000" : "#ff0000", // Green for Connected, Red for Disconnected
                      color: "white",
                      fontSize: "0.85rem",
                      fontWeight: "bold",
                    }}
                  >
                    <Typography variant="body2">
                      {PLConline ? "PLC: Connected" : "PLC: Disconnected"}
                    </Typography>
                  </Box>

                  {/* Signal Status Indicator */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="4px"
                    padding="3px 6px"
                    border="1px solid grey"
                  >
                    <WifiOutlinedIcon
                      style={{ marginRight: "6px", color: iconColor }}
                    />
                    <Typography variant="body2" style={{ color: iconColor }}>
                      {signalStatus}
                    </Typography>
                  </Box>
                </Box>

                {/* Common Time Section (Centered Below) */}
                {convertedProjectTime && (
                  <Box
                    width="100%"
                    marginTop="2px"
                    padding="3px"
                    borderRadius="4px"
                    style={{
                      backgroundColor: "#e0e0e0", // Light grey background for time
                      color: "#333",
                      fontSize: "0.70rem",
                      fontWeight: "bold",
                    }}
                  >
                    <Typography variant="body2">
                      {`Last Comm. Time: ${formatDateTimePlcStatus(
                        convertedProjectTime
                      )}`}
                    </Typography>
                  </Box>
                )}
              </Box>
            )}

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                marginTop: topMargin,
              }}
            >
              {loggedInUser && loggedInUser.VacuumLevelCardEnabled && (
                <Card
                  title="Vacuum Level (bar)"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #B0B0B0", // light blue border
                    transition: "transform 0.3s, box-shadow 0.3s",
                    position: "relative", // Card positioning context
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF", // default background color
                    "&:hover": {
                      backgroundColor: "#e0f7fa", // light blue background on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 6px 15px rgba(135, 206, 250, 0.6)", // light blue shadow on hover
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(173, 216, 230, 0.6), rgba(255, 255, 255, 0.3))", // light blue gradient overlay
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Vaccum_Level}
                        alt="Float Status"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          //borderRadius: '50%',
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        Vacuum Level (bar)
                        <br />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {vacuumlevelLoading ? "Loading..." : receivedOnTime}
                        </span>
                      </Typography>
                    </div>
                    <div
                      style={{ position: "absolute", top: "6px", right: "6px" }}
                    >
                      <Button
                        size="small"
                        onClick={handleVacuumLevelRefresh}
                        style={{
                          color: "#4AA5FF",
                          fontSize: "10px",
                          textTransform: "none",
                          minWidth: "auto",
                          padding: "2px",
                        }}
                      >
                        <RefreshIcon />
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "-18px",
                      marginBottom: "auto",
                    }}
                  >
                    {NoCommunication ? (
                      <Gauge
                        id="gauge-chart1"
                        value={vacuumLevel !== null ? vacuumLevel : 0}
                        startAngle={0}
                        endAngle={360}
                        innerRadius="60%"
                        outerRadius="50%"
                        sx={{
                          "& path": {
                            fill:
                              vacuumLevel >= -0.65 && vacuumLevel <= -0.4
                                ? "#28A745"
                                : "#FF0000",
                          },
                        }}
                        style={{
                          width: "60px",
                          height: "130px",
                          borderRadius: "100%",
                        }}
                      />
                    ) : (
                      <RedCloudIcon />
                    )}
                  </div>
                </Card>
              )}

              {loggedInUser && loggedInUser.TankLevelCardEnabled && (
                <Card
                  title="Tank Level (m)"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #B0B0B0", // light blue border
                    transition: "transform 0.3s, box-shadow 0.3s",
                    position: "relative", // Card positioning context
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF", // default background color
                    "&:hover": {
                      backgroundColor: "#e0f7fa", // light blue background on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(30, 144, 255, 0.4)", // light blue shadow on hover
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(173, 216, 230, 0.6), rgba(255, 255, 255, 0.3))", // light blue gradient overlay
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Tank_Level}
                        alt="Float Status"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "50%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        Tank Level (m)
                        <br />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {tanklevelLoading ? "Loading..." : receivedOnTime}
                        </span>
                      </Typography>
                    </div>
                    <div
                      style={{ position: "absolute", top: "6px", right: "6px" }}
                    >
                      <Button
                        size="small"
                        onClick={handleTankLevel2Refresh}
                        style={{
                          color: "#73BDFE",
                          fontSize: "10px",
                          textTransform: "none",
                          minWidth: "auto",
                          padding: "2px",
                        }}
                      >
                        <RefreshIcon />
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "-18px",
                      marginBottom: "auto",
                    }}
                  >
                    {NoCommunication ? (
                      <Gauge
                        id="gauge-chart1"
                        value={tanklevel !== null ? tanklevel : 0}
                        startAngle={0}
                        endAngle={360}
                        innerRadius="60%"
                        outerRadius="50%"
                        sx={{
                          "& path": {
                            fill:
                              tanklevel > 0.75
                                ? "#FF0000" // Red if tanklevel is greater than 0.75
                                : "#28A745", // Green if tanklevel is less than or equal to 0.75
                          },
                        }}
                        style={{
                          width: "60px",
                          height: "130px",
                          borderRadius: "100%",
                        }}
                      />
                    ) : (
                      <RedCloudIcon />
                    )}
                  </div>
                </Card>
              )}

              {loggedInUser && loggedInUser.VacuumLevel2CardEnabled && (
                <Card
                  title="Vacuum Level Two (bar)"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #36454F",
                    transition:
                      "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF", // default background color
                    "&:hover": {
                      backgroundColor: "#f1f8f6", // light green background on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(40, 167, 69, 0.3)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(40, 167, 69, 0.2), transparent)",
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Vaccum_Level}
                        alt="Vacuum Level (2)"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          //borderRadius: '50%',
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        Vacuum Level (2) (bar)
                        <br />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {vacuumlevelLoading ? "Loading..." : receivedOnTime}
                        </span>
                      </Typography>
                    </div>
                    <div
                      style={{ position: "absolute", top: "6px", right: "6px" }}
                    >
                      <Button
                        size="small"
                        onClick={handleVacuumLevel2Refresh}
                        style={{
                          color: "#4AA5FF",
                          fontSize: "10px",
                          textTransform: "none",
                          minWidth: "auto",
                          padding: "2px",
                        }}
                      >
                        <RefreshIcon />
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "-18px",
                      marginBottom: "auto",
                    }}
                  >
                    {NoCommunication ? (
                      <Gauge
                        id="gauge-chart1"
                        value={vaccum2Level !== null ? vaccum2Level : 0}
                        startAngle={0}
                        endAngle={360}
                        innerRadius="60%"
                        outerRadius="50%"
                        sx={{
                          "& path": {
                            fill:
                              vaccum2Level >= -0.65 && vaccum2Level <= -0.4
                                ? "#28A745"
                                : "#FF0000",
                          },
                        }}
                        style={{
                          width: "60px",
                          height: "130px",
                          borderRadius: "100%",
                        }}
                      />
                    ) : (
                      <RedCloudIcon />
                    )}
                  </div>
                </Card>
              )}

              {loggedInUser && loggedInUser.TankLevel2CardEnabled && (
                <Card
                  title="Tank Level (2)(m)"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #36454F",
                    transition:
                      "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF", // default background color
                    "&:hover": {
                      backgroundColor: "#f1f8f6", // light green background on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(40, 167, 69, 0.3)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(40, 167, 69, 0.2), transparent)",
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Tank_Level}
                        alt="Tank Level Two"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "50%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        Tank Level (2) (m)
                        <br />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {tanklevelLoading ? "Loading..." : receivedOnTime}
                        </span>
                      </Typography>
                    </div>
                    <div
                      style={{ position: "absolute", top: "6px", right: "6px" }}
                    >
                      <Button
                        size="small"
                        onClick={handleTankLevelRefresh}
                        style={{
                          color: "#73BDFE",
                          fontSize: "10px",
                          textTransform: "none",
                          minWidth: "auto",
                          padding: "2px",
                        }}
                      >
                        <RefreshIcon />
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "-18px",
                      marginBottom: "auto",
                    }}
                  >
                    {NoCommunication ? (
                      <Gauge
                        id="gauge-chart1"
                        value={tank2Level !== null ? tank2Level : 0}
                        startAngle={0}
                        endAngle={360}
                        innerRadius="60%"
                        outerRadius="50%"
                        sx={{
                          "& path": {
                            fill:
                              tank2Level > 0.75
                                ? "#FF0000" // Red if tanklevel is greater than 0.75
                                : "#28A745", // Green if tanklevel is less than or equal to 0.75
                          },
                        }}
                        style={{
                          width: "60px",
                          height: "130px",
                          borderRadius: "100%",
                        }}
                      />
                    ) : (
                      <RedCloudIcon />
                    )}
                  </div>
                </Card>
              )}

              {loggedInUser && loggedInUser.VacuumAlarmCardEnabled && (
                <Card
                  title="Vacuum Alarm"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #FFC107",
                    transition:
                      "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#FFF9E6",
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(255, 193, 7, 0.4)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(255, 193, 7, 0.2), transparent)",
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Vaccum_Alarm}
                        alt="Vacuum Alarm"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "50%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Station Alarm
                          <Button
                            size="small"
                            onClick={handleVacuumAlarmRefresh}
                            style={{
                              color: "#FFC107",
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {stationLoading
                            ? "Loading..."
                            : VacAlarmreceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>
                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "55px",
                        borderRadius: "8%",
                        color: "black",
                        fontSize: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {stationLoading ? (
                          <CircularProgress size={25} />
                        ) : openAlarmCount === null ||
                          openAlarmCount === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <Typography variant="body1" style={{ fontSize: 20 }}>
                            {openAlarmCount}
                          </Typography>
                        )}
                      </Box>
                    </div>
                  </CardContent>

                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleVacuumAlarm("Valve Status", e)}
                      style={{
                        color: "#FFC107",
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.PotAlarmCardEnabled && (
                <Card
                  title="Pot Alarm"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #4D499D",
                    transition:
                      "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#E3F2FD",
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(32, 45, 89, 0.3)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(32, 45, 89, 0.15), transparent)",
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Pot_Alarm}
                        alt="Valve Status"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "50%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Pot Alarm
                          <Button
                            size="small"
                            onClick={handleValveAndFloatAlarmRefresh}
                            style={{
                              color: "#4D499D", // Original color
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {valveAndFloatLoading
                            ? "Loading..."
                            : mostRecentValveAndFloatAlarmReceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>
                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "55px",
                        borderRadius: "8%",
                        color: "black",
                        fontSize: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {valveAndFloatLoading ? (
                          <CircularProgress size={24} />
                        ) : totalValveAndFloatAlarmCount === null ||
                          totalValveAndFloatAlarmCount === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <Typography variant="body1" style={{ fontSize: 20 }}>
                            {totalValveAndFloatAlarmCount}
                          </Typography>
                        )}
                      </Box>
                    </div>
                  </CardContent>
                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Valve Status", e)}
                      style={{
                        color: "#4D499D", // Original color
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon /> {/* Icon for expanding */}
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.ValveStatusCardEnabled && (
                <Card
                  title="Valve Status"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #202D59", // Dark blue border
                    transition:
                      "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF", // default background color
                    "&:hover": {
                      backgroundColor: "#E3F2FD", // light blue background on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(32, 45, 89, 0.3)", // light blue shadow on hover
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(32, 45, 89, 0.15), transparent)", // light blue gradient overlay
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Valve_Alarm}
                        alt="Valve Status"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "50%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Valve Alarm
                          <Button
                            size="small"
                            onClick={handleValveAlarmRefresh}
                            style={{
                              color: "#202D59", // Original color
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {valveLoading
                            ? "Loading..."
                            : ValveAlarmreceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>
                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "55px",
                        borderRadius: "8%",
                        color: "black",
                        fontSize: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {valveLoading ? (
                          <CircularProgress size={24} />
                        ) : ValveAlarmCount === null ||
                          ValveAlarmCount === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <Typography variant="body1" style={{ fontSize: 20 }}>
                            {ValveAlarmCount}
                          </Typography>
                        )}
                      </Box>
                    </div>
                  </CardContent>
                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Valve Status", e)}
                      style={{
                        color: "#202D59", // Original color
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon /> {/* Icon for expanding */}
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.FloatStatusCardEnabled && (
                <Card
                  title="Float Status"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #364BB3",
                    transition:
                      "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF", // default background color
                    "&:hover": {
                      backgroundColor: "#BBDEFB", // medium light blue background on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(32, 45, 89, 0.4)", // medium blue shadow on hover
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(135deg, rgba(32, 45, 89, 0.3), transparent)", // medium light blue gradient overlay
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Float_Alarm}
                        alt="Float Status"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "50%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Float Alarm
                          <Button
                            size="small"
                            onClick={handleFlatAlarmRefresh}
                            style={{
                              color: "#3953BD", // Original color
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {floatLoading
                            ? "Loading..."
                            : FloatAlarmreceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>
                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "55px",
                        borderRadius: "8%",
                        color: "black",
                        fontSize: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {floatLoading ? (
                          <CircularProgress size={24} />
                        ) : FloatAlarmCount === null ||
                          FloatAlarmCount === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <Typography variant="body1" style={{ fontSize: 20 }}>
                            {FloatAlarmCount}
                          </Typography>
                        )}
                      </Box>
                    </div>
                  </CardContent>
                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleFloatStatus("Float Status", e)}
                      style={{
                        color: "#3953BD", // Original color
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon /> {/* Icon for expanding */}
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.TotalValveCyclesCardEnabled && (
                <Card
                  title="Total Valve Cycles"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #03A9F4", // Light Blue
                    transition: "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#E1F5FE", // Light Blue hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(2, 136, 209, 0.3)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(135deg, rgba(3, 169, 244, 0.15), transparent)", // Gradient light blue
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Total_Valve_Cycles}
                        alt="Total Valve Cycles"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "10%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Total Valve Cycles
                          <Button
                            size="small"
                            onClick={handleTotalValveCycles}
                            style={{
                              color: "#0288D1", // Light blue icon
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {totalValveCyclesLoading
                            ? "Loading..."
                            : mostRecentValveAndFloatAlarmReceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>

                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "55px",
                        borderRadius: "8%",
                        color: "black",
                        fontSize: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {totalValveCyclesLoading ? (
                          <CircularProgress size={24} />
                        ) : totalValveCycles === null ||
                          totalValveCycles === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <Typography variant="body1" style={{ fontSize: 20 }}>
                                {totalValveCycles || 0}
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{
                                  color: "#555",
                                  fontSize: 13,
                                  fontWeight: 500,
                                  marginTop: 2,
                                }}
                              >
                                (Cycles)
                              </Typography>
                            </div>
                          </>
                        )}
                      </Box>
                    </div>
                  </CardContent>

                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Valve Status", e)}
                      style={{
                        color: "#0288D1", // Light blue icon
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.TotalValveDurationCardEnabled && (
                <Card
                  title="Total Valve Duration"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #FFA000", // Amber
                    transition: "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#FFECB3", // Amber hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(255, 160, 0, 0.3)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(135deg, rgba(255, 160, 0, 0.15), transparent)", // Amber gradient
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Total_Valve_Duration}
                        alt="Total Valve Duration"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "10%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Total Valve Duration
                          <Button
                            size="small"
                            onClick={handleTotalValveDuration}
                            style={{
                              color: "#FB8C00", // Amber icon
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {totalValveDurationLoading
                            ? "Loading..."
                            : mostRecentValveAndFloatAlarmReceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>

                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "55px",
                        borderRadius: "8%",
                        color: "black",
                        fontSize: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {totalValveDurationLoading ? (
                          <CircularProgress size={24} />
                        ) : totalValveDuration === null ||
                          totalValveDuration === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <Typography variant="body1" style={{ fontSize: 18 }}>
                                {totalValveDuration || '00:00:00:00'}
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{
                                  color: "#555",
                                  fontSize: 13,
                                  fontWeight: 500,
                                  marginTop: 2,
                                }}
                              >
                                (DD:HH:MM:SS)
                              </Typography>
                            </div>

                          </>
                        )}
                      </Box>
                    </div>
                  </CardContent>

                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Valve Status", e)}
                      style={{
                        color: "#FB8C00", // Amber icon
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.BatteryCardEnabled && (
                <Card
                  title="Battery"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #4CAF50", // ✅ Green border
                    transition: "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#E8F5E9", // ✅ Light green hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.3)", // ✅ Green shadow
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(135deg, rgba(76, 175, 80, 0.15), transparent)", // ✅ Green gradient
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Battery}
                        alt="Battery"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "10%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Battery
                          <Button
                            size="small"
                            onClick={handleAverageBattery}
                            style={{
                              color: "#388E3C", // ✅ Green icon color
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {averageBatteryVoltageLoading
                            ? "Loading..."
                            : mostRecentValveAndFloatAlarmReceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>

                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "55px",
                        borderRadius: "8%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {averageBatteryVoltageLoading ? (
                          <CircularProgress size={24} />
                        ) : averageBatteryVoltage === null || averageBatteryVoltage === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <>
                            <Typography variant="body1" style={{ fontSize: 20, color: "#000" }}>
                              {averageBatteryVoltage || 0}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{
                                marginLeft: 2,
                                color: "#555", // dark grey for 'V'
                                fontSize: 14,
                                fontWeight: 500,
                                marginTop: 4,
                              }}
                            >
                              V
                            </Typography>
                          </>
                        )}
                      </Box>
                    </div>
                  </CardContent>

                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Valve Status", e)}
                      style={{
                        color: "#388E3C", // ✅ Green icon color
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </CardActions>
                </Card>
              )}

              {loggedInUser && loggedInUser.HumidityCardEnabled && (
                <Card
                  title="Humidity"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #9C27B0", // Purple
                    transition: "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#F3E5F5", // Lavender hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(156, 39, 176, 0.3)", // Purple shadow
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(135deg, rgba(156, 39, 176, 0.15), transparent)", // Gradient purple
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Humidity}
                        alt="Humidity"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "10%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Humidity
                          <Button
                            size="small"
                            onClick={handleAverageHumidity}
                            style={{
                              color: "#9C27B0", // Purple refresh icon
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {averageHumidityLoading
                            ? "Loading..."
                            : mostRecentValveAndFloatAlarmReceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>

                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "55px",
                        borderRadius: "8%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {averageHumidityLoading ? (
                          <CircularProgress size={24} />
                        ) : averageHumidity === null || averageHumidity === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <>
                            <Typography variant="body1" style={{ fontSize: 20, color: "#000" }}>
                              {averageHumidity || 0}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{
                                marginLeft: 2,
                                color: "#555", // dark grey for 'V'
                                fontSize: 15,
                                fontWeight: 500,
                                marginTop: 4,
                              }}
                            >
                              %
                            </Typography>
                          </>
                        )}
                      </Box>
                    </div>
                  </CardContent>

                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Valve Status", e)}
                      style={{
                        color: "#9C27B0", // Purple expand icon
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </CardActions>
                </Card>
              )}
              {loggedInUser && loggedInUser.TemperatureCardEnabled && (
                <Card
                  title="Temperature"
                  sx={{
                    maxWidth: 280,
                    maxHeight: 160,
                    borderBottom: "3px solid #D4AF37", // Dark Gold
                    transition: "transform 0.3s, box-shadow 0.3s, background-color 0.3s",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#FFFDE7", // Light yellow on hover
                      transform: "scale(1.04)",
                      cursor: "pointer",
                      boxShadow: "0px 4px 12px rgba(212, 175, 55, 0.3)",
                    },
                    flex: "1 1 250px",
                    margin: "10px",
                    borderRadius: "0px",
                    "@media (max-width: 600px)": {
                      maxHeight: 220,
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(135deg, rgba(212, 175, 55, 0.15), transparent)", // Soft gold overlay
                      borderRadius: "inherit",
                      zIndex: "-1",
                      transition: "opacity 0.3s ease",
                      opacity: 0,
                    },
                    "&:hover::before": {
                      opacity: 1,
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px",
                      borderBottom: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      position: "relative",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={Temperature}
                        alt="Temperature"
                        style={{
                          maxHeight: "35px",
                          maxWidth: "35px",
                          objectFit: "contain",
                          marginRight: "10px",
                          borderRadius: "10%",
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        component="div"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "left",
                          margin: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Temperature
                          <Button
                            size="small"
                            onClick={handleAverageTemperature}
                            style={{
                              color: "#B8860B", // Dark gold icon
                              fontSize: "10px",
                              textTransform: "none",
                              minWidth: "auto",
                              padding: "2px",
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            margin: "0",
                            color: "#757575",
                          }}
                        >
                          Received On:{" "}
                          {averageTemperatureLoading
                            ? "Loading..."
                            : mostRecentValveAndFloatAlarmReceivedOnTime}
                        </span>
                      </Typography>
                    </div>
                  </div>

                  {/* Content */}
                  <CardContent
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "55px",
                        borderRadius: "8%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        {averageTemperatureLoading ? (
                          <CircularProgress size={24} />
                        ) : averageTemperature === null || averageTemperature === undefined ? (
                          <Typography variant="body2" color="textSecondary">
                            Loading...
                          </Typography>
                        ) : (
                          <>
                            <Typography variant="body1" style={{ fontSize: 20, color: "#000" }}>
                              {averageTemperature || 0}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{
                                marginLeft: 2,
                                color: "#555", // dark grey for 'V'
                                fontSize: 15,
                                fontWeight: 500,
                              }}
                            >
                              °C
                            </Typography>
                          </>
                        )}
                      </Box>
                    </div>
                  </CardContent>

                  {/* Footer */}
                  <CardActions
                    style={{
                      justifyContent: "flex-end",
                      borderTop: "1px solid #F2F2F2",
                      backgroundColor: "#FAFAFA",
                      padding: "2px",
                      minHeight: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={(e) => handleValveStatus("Temperature", e)}
                      style={{
                        color: "#B8860B", // Button icon dark gold
                        fontSize: "10px",
                        textTransform: "none",
                        minWidth: "auto",
                        padding: "2px",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </CardActions>
                </Card>
              )}

            </div>
          </Card>
        </MainContent>
      </ContentContainer>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
      />
      <ToastContainer />
    </div>
  );
};

export default Dashboard;
